import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NotificationService } from '../../../../Services/notification.service';
import { FirmSelectionService } from '../../../../Services/firm-selection.service';
import { NavbarService } from '../../../../Services/navbar.service';
import { AuthService } from '../../../../Services/auth.service';
import { UserStaffService } from '../../../../Services/User/Staff/user-staff.service';
import { CustomizeService } from '../../../../Services/Customize_settings/customize.service';
import { UserAccessService } from '../../../../Services/UserAccess/user-access.service';

@Component({
  selector: 'app-admin-panel',
  standalone: true,
  imports: [
    CommonModule,
    RouterOutlet,
  ],
  templateUrl: './admin-panel.component.html',
  styleUrls: ['./admin-panel.component.css'],
})
export class AdminPanelComponent implements OnInit {
  selectedFirmName: string | null = null;
  userName: string | null = null;
  isSidebarCollapsed = false;
  activeTab: string = '';
  role: string | null = null;
  logoImage: any;
  allowedSubPaths: string[] = [];

  constructor(
    private notificationService: NotificationService,
    private firmSelectionService: FirmSelectionService,
    private navbarService: NavbarService,
    private authService: AuthService,
    private userStaffService: UserStaffService,
    private router: Router,
    private customizeService: CustomizeService,
    private userAccessService: UserAccessService
  ) { }

  ngOnInit(): void {
    // 🔥 Listen for logo changes
    this.customizeService.logo$.subscribe((logo) => {
      if (logo) {
        this.logoImage = logo;
      }
    });

    this.role = this.authService.getUserRole();
    console.log('Logged-in Role:', this.role);

    this.firmSelectionService.selectedFirmName$.subscribe((firm: any) => {
      this.selectedFirmName = firm?.name || 'My Firm';
    });

    this.userStaffService.getUserStaffById(this.authService.getUserId()).subscribe((res: any) => {
      const userData = res.data;
      console.log("User Data", userData);

      if (userData) {
        this.userName = userData.name;
      }
    });

    if (this.role === 'Staff') {
      this.loadPermissions();
    }

    this.notificationService.showInfo('Welcome to Admin Panel', 'Info');
    this.setActiveTabFromRoute();
  }

  loadPermissions() {
    const userId = this.authService.getUserId();
    if (!userId) return;
    this.userAccessService.getUserAccess(userId).subscribe({
      next: (res: any) => {
        if (res?.data) {
          this.allowedSubPaths = (res.data.submenu_visibility || []).map((p: string) => p.startsWith('/') ? p : '/' + p);
        }
      },
      error: (err) => {
        console.error('Failed to load settings permissions', err);
      }
    });
  }

  hasSubAccess(path: string): boolean {
    if (this.role !== 'Staff') return true;
    return this.allowedSubPaths.includes(path);
  }

  hasCategoryAccess(): boolean {
    if (this.role !== 'Staff') return true;
    return this.hasSubAccess('/admin-panel/category-parent/add-category') ||
           this.hasSubAccess('/admin-panel/category-parent/sub-category') ||
           this.hasSubAccess('/admin-panel/category-parent/assembly_brand');
  }

  hasKalakarAccess(): boolean {
    if (this.role !== 'Staff') return true;
    return this.hasSubAccess('/admin-panel/list-kalakar') ||
           this.hasSubAccess('/admin-panel/admin-kalakar');
  }

  private setActiveTabFromRoute(): void {
    const currentUrl = this.router.url;

    if (currentUrl === '/admin-panel/add-category') {
      this.activeTab = 'add-category';
    } else if (currentUrl === '/admin-panel/dropdown-setting') {
      this.activeTab = 'dropdown-setting';
    }
    else if (currentUrl.includes('/set-type')) {
      this.activeTab = 'set-type';

    }
    //  else if (currentUrl.includes('/admin-customize-invoice')) {
    //   this.activeTab = 'Invoice Layout';

    //  }
    else if (currentUrl.includes('/admin-customize-invoice')) {
      this.activeTab = 'Rough Estimate';

    }
    else if (currentUrl.includes('/asset-form')) {
      this.activeTab = 'Add Assets';

    }

    else if (currentUrl.includes('/rate-List')) {
      this.activeTab = 'Rate List';

    }

    else if (currentUrl.includes('/stafflistadmin')) {
      this.activeTab = 'stafflistadmin';

    }

    else if (currentUrl.includes('/whatsapp-instance')) {
      this.activeTab = 'whatsapp-instance';

    }

    else if (
      currentUrl.startsWith('/admin-panel/list-kalakar') ||
      currentUrl.startsWith('/admin-panel/admin-kalakar')
    ) {
      this.activeTab = 'kalakar';
    } else if (currentUrl.includes('/expense-type')) {
      this.activeTab = 'expense-type';
    } else if (currentUrl.includes('/weighing-scale-setting')) {
      this.activeTab = 'weighing-scale-setting';
    } else {
      this.activeTab = '';
    }
  }

  openTab(tab: string): void {
    this.activeTab = tab;

    switch (tab) {
      case 'add-category':
        this.router.navigate(['/admin-panel/category-parent']);
        break;
      case 'dropdown-setting':
        this.router.navigate(['/admin-panel/dropdown-setting']);
        break;
      case 'kalakar-setting':
        this.router.navigate(['/admin-panel/list-kalakar']);
        break;
      case 'set-type':
        this.router.navigate(['/admin-panel/set-type']);
        break;
      //  case 'Invoice Layout':
      //   this.router.navigate(['/admin-panel/admin-customize-invoice']);
      //   break;
      case 'Rough Estimate':
        this.router.navigate(['/admin-panel/rough-estimate-customization']);
        break;
      case 'Add Assets':
        this.router.navigate(['/admin-panel/asset-form']);
        break;
      case 'Rate List':
        this.router.navigate(['/admin-panel/rate-List']);
        break;
      case 'stafflistadmin':
        this.router.navigate(['/admin-panel/stafflistadmin']);
        break;
      case 'whatsapp-instance':
        this.router.navigate(['/admin-panel/whatsapp-instance']);
        break;
      case 'expense-type':
        this.router.navigate(['/admin-panel/expense-type']);
        break;
      case 'weighing-scale-setting':
        this.router.navigate(['/admin-panel/weighing-scale-setting']);
        break;
    }
  }


  toggleSidebar(): void {
    this.isSidebarCollapsed = !this.isSidebarCollapsed;
  }

  logout(): void {
    this.notificationService.showSuccess('Logged out successfully.', 'Logout');
    this.authService.logout();
  }

  isMobileOpen = false;

  toggleMobileSidebar() {
    this.isMobileOpen = !this.isMobileOpen;
  }

}

